var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.visible)?_c('div',{staticClass:"toast-container",class:'toast-' + _vm.type,on:{"click":_vm.dismiss}},[_c('span',{staticClass:"toast-icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.iconName}})],1),_c('span',{staticClass:"toast-message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }